import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { selectCanDoRiskQuestionnaire } from '../../../../../../CommonSelectors/CommonAreaSelector';

interface HiddenLeversResultsEmptyProps {
  onRetakeAssessment?: () => void;
}

export const HiddenLeversRiskScoreEmpty = ({
  onRetakeAssessment,
}: HiddenLeversResultsEmptyProps) => {
  const canDoRiskQuestionnaire = useSelector(selectCanDoRiskQuestionnaire);

  return (
    <Card
      p="32"
      mb="16"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text fontSize="h6" fontWeight={600}>
        Missing Client Risk Score
      </Text>

      {canDoRiskQuestionnaire && onRetakeAssessment && (
        <Button variant="link" onClick={onRetakeAssessment} mt="24">
          Take Risk Assessment
        </Button>
      )}
    </Card>
  );
};
